import {Route, Routes} from 'react-router-dom';
import {ListAudiencesPage} from "../pages/list-audiences-page/list-audiences-page";
import {EditAudiencePage} from "../pages/edit-audience-page/edit-audience-page";

export const AudiencesRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<ListAudiencesPage />} />
      <Route path="/:audienceId" element={<EditAudiencePage />} />
    </Routes>
  );
};
